import AddMerchantDialog from './AddMerchantDialog';

export default AddMerchantDialog;